export default __webpack_public_path__ + "static/hill-5a5fb0f20a4c547edada6beb76eb2cab.jpg";